"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _material = require("@mui/material");

var _services = require("@alycecom/services");

var _query = require("@reduxjs/toolkit/query");

var _DefaultProducts = _interopRequireDefault(require("../DefaultProducts/DefaultProducts"));

var _hooks = require("../../../../hooks");

var _providers = require("../../../../providers");

var _StepperFooter = _interopRequireDefault(require("../../../../components/Stepper/StepperFooter"));

var _components = require("../../../../components");

var _batch = require("../../../SendingBatch/constants/batch.types");

var _useTrackGiftingFlow = require("../../../../hooks/useTrackGiftingFlow");

var _giftingFlow = require("../../../../helpers/giftingFlow.helpers");

var _activeStep = require("../../../../store/ui/activeStep");

var SelectProduct = function SelectProduct(_ref) {
  var _batch$defaultProduct, _batch$defaultProduct2, _campaign$defaultProd3, _campaign$defaultProd4, _campaign$defaultProd8, _campaign$defaultProd9, _campaign$defaultProd10, _campaign$defaultProd11;

  var renderMarketplace = _ref.renderMarketplace;

  var _useGiftingFlowContex = (0, _providers.useGiftingFlowContext)(),
      batchId = _useGiftingFlowContex.batchId;

  var _useGetProspectingBat = (0, _services.useGetProspectingBatchByIdQuery)(batchId ? {
    batchId: Number(batchId)
  } : _query.skipToken),
      batch = _useGetProspectingBat.data,
      isBatchFulfilled = _useGetProspectingBat.isSuccess;

  var _useGetCampaignByIdQu = (0, _services.useGetCampaignByIdQuery)((batch === null || batch === void 0 ? void 0 : batch.campaignId) || _query.skipToken),
      campaign = _useGetCampaignByIdQu.data;

  var _usePutProspectingBat = (0, _services.usePutProspectingBatchDefaultProductByIdMutation)(),
      _usePutProspectingBat2 = (0, _slicedToArray2.default)(_usePutProspectingBat, 2),
      setDefaultProduct = _usePutProspectingBat2[0],
      isLoading = _usePutProspectingBat2[1].isLoading;

  var _GlobalMessage$useGlo = _services.GlobalMessage.useGlobalMessage(),
      showGlobalMessage = _GlobalMessage$useGlo.showGlobalMessage;

  var _useGiftingFlowSteps = (0, _hooks.useGiftingFlowSteps)(),
      setActiveStep = _useGiftingFlowSteps.setActiveStep,
      goToNextStep = _useGiftingFlowSteps.goToNextStep;

  var defaultProductIds = (0, _react.useMemo)(function () {
    var _campaign$defaultProd, _campaign$defaultProd2;

    return (_campaign$defaultProd = campaign === null || campaign === void 0 ? void 0 : (_campaign$defaultProd2 = campaign.defaultProducts) === null || _campaign$defaultProd2 === void 0 ? void 0 : _campaign$defaultProd2.map(function (product) {
      return product.id;
    })) !== null && _campaign$defaultProd !== void 0 ? _campaign$defaultProd : [];
  }, [campaign]);
  var calculatedStep = (0, _giftingFlow.getBatchLastStep)({
    batch
  });

  var _useState = (0, _react.useState)((_batch$defaultProduct = batch === null || batch === void 0 ? void 0 : batch.defaultProduct) !== null && _batch$defaultProduct !== void 0 ? _batch$defaultProduct : null),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      value = _useState2[0],
      setValue = _useState2[1];

  var isDirty = (batch === null || batch === void 0 ? void 0 : (_batch$defaultProduct2 = batch.defaultProduct) === null || _batch$defaultProduct2 === void 0 ? void 0 : _batch$defaultProduct2.id) !== (value === null || value === void 0 ? void 0 : value.id);
  var isDisabled = !batchId || !value;
  var trackGiftingFlowSelectGiftStepProductClicked = (0, _useTrackGiftingFlow.useGiftingFlowSelectGiftStepProductClicked)();
  var trackGiftingFlowSelectGiftStepNextButtonClicked = (0, _useTrackGiftingFlow.useGiftingFlowSelectGiftStepNextButtonClicked)();
  var hasDefaultProducts = ((_campaign$defaultProd3 = campaign === null || campaign === void 0 ? void 0 : (_campaign$defaultProd4 = campaign.defaultProducts) === null || _campaign$defaultProd4 === void 0 ? void 0 : _campaign$defaultProd4.length) !== null && _campaign$defaultProd3 !== void 0 ? _campaign$defaultProd3 : 0) > 0;
  var hasMarketplace = Boolean(campaign === null || campaign === void 0 ? void 0 : campaign.productsOverrideEnabled);
  var getIsDefaultProduct = (0, _react.useCallback)(function (product) {
    var _campaign$defaultProd5;

    return Boolean(campaign === null || campaign === void 0 ? void 0 : (_campaign$defaultProd5 = campaign.defaultProducts) === null || _campaign$defaultProd5 === void 0 ? void 0 : _campaign$defaultProd5.find(function (item) {
      return item.id === (product === null || product === void 0 ? void 0 : product.id);
    }));
  }, [campaign]);
  var handleSetProduct = (0, _react.useCallback)(function (product) {
    var _campaign$defaultProd6, _campaign$defaultProd7;

    setValue(product);
    trackGiftingFlowSelectGiftStepProductClicked({
      product,
      isMarketplaceAvailable: hasMarketplace,
      defaultGiftsCount: (_campaign$defaultProd6 = campaign === null || campaign === void 0 ? void 0 : (_campaign$defaultProd7 = campaign.defaultProducts) === null || _campaign$defaultProd7 === void 0 ? void 0 : _campaign$defaultProd7.length) !== null && _campaign$defaultProd6 !== void 0 ? _campaign$defaultProd6 : 0,
      isDefault: getIsDefaultProduct(product)
    });
  }, [campaign, hasMarketplace, trackGiftingFlowSelectGiftStepProductClicked, getIsDefaultProduct]);

  var handleSubmit = function handleSubmit(event) {
    event.preventDefault();

    if (value && !isDirty) {
      setActiveStep(calculatedStep);
      return;
    }

    if (value && batchId) {
      var _value$denomination;

      setDefaultProduct({
        body: {
          id: value.id,
          denomination: (_value$denomination = value.denomination) !== null && _value$denomination !== void 0 ? _value$denomination : null
        },
        batchId
      }).unwrap().then(function () {
        if ((batch === null || batch === void 0 ? void 0 : batch.giftsCreationStatus) === _batch.BatchGiftsCreationStatus.Finished) {
          setActiveStep(_activeStep.GiftingFlowStep.Send);
        } else {
          goToNextStep();
        }

        showGlobalMessage({
          type: _services.MessageType.Success,
          text: 'Product chose successfully'
        });
      });
      trackGiftingFlowSelectGiftStepNextButtonClicked({
        product: value,
        isDefault: getIsDefaultProduct(value)
      });
    }
  };

  var batchProduct = batch === null || batch === void 0 ? void 0 : batch.defaultProduct;
  var isBatchProductShouldBeSelected = !!batchProduct && !value;
  (0, _react.useEffect)(function () {
    if (isBatchProductShouldBeSelected && batchProduct) {
      setValue(batchProduct);
    }
  }, [batchProduct, isBatchProductShouldBeSelected]);
  var productSelectedByDefault = (_campaign$defaultProd8 = campaign === null || campaign === void 0 ? void 0 : (_campaign$defaultProd9 = campaign.defaultProducts) === null || _campaign$defaultProd9 === void 0 ? void 0 : _campaign$defaultProd9[0]) !== null && _campaign$defaultProd8 !== void 0 ? _campaign$defaultProd8 : null;
  var isDefaultProductShouldBeSaved = (campaign === null || campaign === void 0 ? void 0 : (_campaign$defaultProd10 = campaign.defaultProducts) === null || _campaign$defaultProd10 === void 0 ? void 0 : _campaign$defaultProd10.length) === 1 && !(batch !== null && batch !== void 0 && batch.defaultProduct) && isBatchFulfilled && !hasMarketplace;
  (0, _react.useEffect)(function () {
    if (isDefaultProductShouldBeSaved && productSelectedByDefault) {
      handleSetProduct(productSelectedByDefault);
    }
  }, [productSelectedByDefault, isDefaultProductShouldBeSaved, handleSetProduct]);
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_components.StepTitle, {
    title: "Select Gift",
    subTitle: "Step 2/4"
  }), /*#__PURE__*/_react.default.createElement(_material.Box, {
    component: "form",
    onSubmit: handleSubmit,
    display: "flex",
    flexDirection: "column"
  }, hasDefaultProducts && /*#__PURE__*/_react.default.createElement(_DefaultProducts.default, {
    products: (_campaign$defaultProd11 = campaign === null || campaign === void 0 ? void 0 : campaign.defaultProducts) !== null && _campaign$defaultProd11 !== void 0 ? _campaign$defaultProd11 : [],
    onSelect: handleSetProduct,
    value: value
  }), hasDefaultProducts && hasMarketplace && /*#__PURE__*/_react.default.createElement(_material.Box, {
    my: 2,
    display: "flex",
    justifyContent: "center",
    fontWeight: 700
  }, "or"), hasMarketplace && /*#__PURE__*/_react.default.createElement(_material.Box, {
    height: 1,
    bgcolor: "common.white",
    p: 1
  }, /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_material.Box, {
    color: "primary.main",
    fontSize: "14px",
    lineHeight: "16px",
    fontWeight: 700
  }, "Browse the Marketplace"), !!campaign && renderMarketplace({
    onSelect: handleSetProduct,
    value,
    campaignId: campaign.id,
    campaign,
    defaultProductIds
  }))), /*#__PURE__*/_react.default.createElement(_StepperFooter.default, {
    disabled: isDisabled,
    isLoading: isLoading
  })));
};

var _default = SelectProduct;
exports.default = _default;